"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteAttributeDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const delete_from_other_nodes_dialog_component_1 = require("../delete-from-other-nodes-dialog.component");
const delete_attribute_dialog_styles_1 = require("./delete-attribute-dialog.styles");
const attributes_1 = require("../../../../client/attributes");
const hooks_1 = require("../../../../client/hooks");
const values_1 = require("../../../../client/values");
const global_tree_edit_warning_1 = require("../../../../components/global-tree-edit-warning");
const context_1 = require("../../../../context");
const generic_1 = require("../../../../generic");
const hooks_2 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const DeleteAttributeDialog = ({ open, onClose, onDeleteAttributesInSelectedNode, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { refetchQueriesOnStrategyAttributeChange, refetchQueriesOnStrategyValueChange } = (0, hooks_1.useRefetchQueries)();
    const { addError, addSuccess } = (0, hooks_2.useNotification)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const shouldShowGlobalTreeEditWarning = (0, store_1.useShouldShowGlobalTreeEditWarning)();
    const { checkedIds = [], isValueCheckMode, checkedItemTypeTitle, correspondingAttributeInValueCheckMode, clearCheckedIds, getCheckedEntityLabels, } = (0, context_1.useCheckedAttributes)();
    const { deleteAttributesFromSeveralNodes } = (0, attributes_1.useDeleteAttributesFromSeveralNodes)();
    const { deleteValuesFromSeveralNodes } = (0, values_1.useDeleteValuesFromSeveralNodes)();
    const [isDeleteFromOthersDialogOpen, setIsDeleteFromOthersDialogOpen] = (0, react_1.useState)(false);
    const [isDeleteFromSelectedNodeLoading, setIsDeleteFromSelectedNodeLoading] = (0, react_1.useState)(false);
    const [isDeleteFromOtherNodesLoading, setIsDeleteFromOtherNodesLoading] = (0, react_1.useState)(false);
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const [isGlobalStrategyReplacementAccepted, onStrategyReplacementAcceptChange] = (0, react_1.useState)(false);
    const isTreeReplacementNeeded = shouldShowGlobalTreeEditWarning && isGlobalStrategyReplacementAccepted;
    const { onGlobalTreeReplacement } = (0, global_tree_edit_warning_1.useGlobalTreeEditWarning)(selectedStrategyNodeId);
    const localizationMessageValues = { count: checkedIds.length, entity: checkedItemTypeTitle };
    const checkedLabels = (0, react_1.useMemo)(() => getCheckedEntityLabels(), [getCheckedEntityLabels]);
    const handleAddItemsToHistory = (ids, treeNodePaths, entityType) => {
        const historyItems = [];
        for (const id of ids) {
            for (const treeNodePath of treeNodePaths) {
                const historyItem = {
                    id,
                    entityType,
                    actionType: store_1.ChangeActionType.Delete,
                    path: treeNodePath,
                };
                historyItems.push(historyItem);
            }
        }
        dispatch((0, store_1.enrichAIAddChanges)(selectedCatalogId, historyItems));
    };
    const handleDeleteCheckedItems = (treeNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        if (isValueCheckMode) {
            const attributeLabel = correspondingAttributeInValueCheckMode;
            const updatedTreeNodePaths = yield deleteValuesFromSeveralNodes(attributeLabel, checkedLabels, treeNodeIds);
            const historyIds = checkedLabels.map((value) => `${attributeLabel}${store_1.LABEL_VALUE_PAIR_SEPARATOR}${value}`);
            handleAddItemsToHistory(historyIds, updatedTreeNodePaths, store_1.ChangeEntityType.Value);
        }
        else {
            const updatedTreeNodePaths = yield deleteAttributesFromSeveralNodes(checkedLabels, treeNodeIds);
            handleAddItemsToHistory(checkedLabels, updatedTreeNodePaths, store_1.ChangeEntityType.Attribute);
        }
    });
    const handleTreeReplacement = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isTreeReplacementNeeded) {
            return { targetNodeId: selectedStrategyNodeId };
        }
        const metadata = yield onGlobalTreeReplacement();
        if (!metadata.targetNodeId) {
            throw new Error('Target node is not found');
        }
        return metadata;
    });
    const handleDeleteAttributesInSelectedNode = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsDeleteFromSelectedNodeLoading(true);
        try {
            const { targetNodeId } = yield handleTreeReplacement();
            yield handleDeleteCheckedItems([targetNodeId]);
            onDeleteAttributesInSelectedNode();
            setIsDeleteFromOthersDialogOpen(true);
        }
        catch (error) {
            addError(t({ key: 'DELETE_ENTITY_ERROR', values: localizationMessageValues }), error.message);
        }
        finally {
            setIsDeleteFromSelectedNodeLoading(false);
            onStrategyReplacementAcceptChange(false);
            onClose();
        }
    });
    const handleUpdateProductPresentation = (relatedTreeNodeIds) => {
        if (isValueCheckMode) {
            void refetchQueriesOnStrategyValueChange({
                selectedTreeNodeId: selectedStrategyNodeId,
                attributeName: correspondingAttributeInValueCheckMode,
                relatedTreeNodeIds,
            });
        }
        else {
            void refetchQueriesOnStrategyAttributeChange({
                selectedTreeNodeId: selectedStrategyNodeId,
                relatedTreeNodeIds,
            });
        }
        clearCheckedIds();
    };
    const handleClose = () => {
        setIsDeleteFromOthersDialogOpen(false);
        void handleUpdateProductPresentation();
    };
    const handleDeleteFromOtherNodes = (treeNodeIds) => __awaiter(void 0, void 0, void 0, function* () {
        setIsDeleteFromOtherNodesLoading(true);
        const localizationMessageValues = { count: checkedIds.length, entity: checkedItemTypeTitle };
        try {
            yield handleDeleteCheckedItems(treeNodeIds);
            addSuccess(t({ key: 'DELETE_ENTITY_SUCCESS', values: localizationMessageValues }));
            void handleUpdateProductPresentation(treeNodeIds);
        }
        catch (error) {
            addError(t({ key: 'DELETE_ENTITY_ERROR', values: localizationMessageValues }), error);
            void handleUpdateProductPresentation();
        }
        finally {
            setIsDeleteFromOtherNodesLoading(false);
            setIsDeleteFromOthersDialogOpen(false);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(delete_attribute_dialog_styles_1.StyledDialog, { open: true, title: t({ key: 'CONFIRMATION_DELETE_TITLE', values: localizationMessageValues }), proceedButtonProps: {
            error: true,
            title: t({ key: 'DELETE' }),
            onClick: handleDeleteAttributesInSelectedNode,
            disabled: isDeleteFromSelectedNodeLoading || (shouldShowGlobalTreeEditWarning && !isGlobalStrategyReplacementAccepted),
            endIcon: isDeleteFromSelectedNodeLoading && react_1.default.createElement(generic_1.LoadingIndicator, null),
        }, cancelButtonProps: { title: t({ key: 'CANCEL' }), onClick: onClose } }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(generic_1.ActionDialogContent, null, react_1.default.createElement(ui_components_1.Typography, { variant: "caption" }, t({ key: 'DELETE_DIALOG_WARNING_MESSAGE' })), checkedLabels.map((label, index) => react_1.default.createElement(generic_1.ListRowItem, { key: index, text: label }))), shouldShowGlobalTreeEditWarning && (react_1.default.createElement(global_tree_edit_warning_1.GlobalTreeEditWarning, { isChecked: isGlobalStrategyReplacementAccepted, onChange: onStrategyReplacementAcceptChange }))))), isDeleteFromOthersDialogOpen && (react_1.default.createElement(delete_from_other_nodes_dialog_component_1.DeleteFromOtherNodesDialog, { onClose: handleClose, onSubmit: handleDeleteFromOtherNodes, isLoading: isDeleteFromOtherNodesLoading }))));
};
exports.DeleteAttributeDialog = DeleteAttributeDialog;
exports.default = exports.DeleteAttributeDialog;
